import React from "react";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { bindActionCreators } from "redux";
import * as IssueTypesActions from "../../../store/actions/IssueTypes";
import * as SubIssueTypeActions from "../../../store/actions/SubIssueTypes";
import { isValNull } from "../../../utils";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";

const SubIssueTypeFilterModal = (props) => {
  const enabledType = ["Yes", "No"];
  const {
    handleModalClose,
    issueArea,
    getIssueArea,
    activeFilters,
    setSubIssueTypeActiveFilters,
    getSubIssueTypeList,
    getIssueTypeRemoteSearch,
    remoteSearch,
    currentPage,
  } = props;
  const [priorityFlag, setPriorityFlag] = React.useState(true);
  const [filterFieldState, setFilterFieldState] = React.useState({
    issueType: null,
    issueTypeId: null,
    name: "",
    externalMappingName: "",
    enabled: null,
    issueArea: "",
    zendeskArticleId: null,
  });
  React.useEffect(() => {
    if (issueArea.length === 0) {
      getIssueArea();
    }
  }, []);
  React.useEffect(() => {
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...filterFieldState };
      Object.keys(values).map((item, index) => {
        if (!isValNull(activeFilters[item])) {
          values[item] = activeFilters[item] ? activeFilters[item] : "";
        }
      });
      setFilterFieldState(values);
    }
  }, [activeFilters]);

  const handleChange = (key, value) => {
    if (key === "issueType" || key === "issueTypeId") {
      setPriorityFlag(!priorityFlag);
      setFilterFieldState((prevState) => {
        return {
          ...prevState,
          issueType: value,
          issueTypeId:
            typeof value === "number" ? JSON.stringify(value) : value,
        };
      });
      // setPriorityFlag(true);
    } else {
      setFilterFieldState((prevState) => {
        return { ...prevState, [key]: value };
      });
    }
  };

  const handleSubmit = () => {
    getSubIssueTypeList(1, filterFieldState).then((res) => {
      // setSubIssueTypeActiveFilters(activeFiltersObj);
      if (res) handleModalClose();
    });
  };

  const handleClearFilters = () => {
    getSubIssueTypeList(1, {}).then((res) => {
      setSubIssueTypeActiveFilters({});
      handleModalClose();
    });
  };
  // to get active element by id
  const getActiveItemById = async (id) => {
    for (let i = 0; i < remoteSearch.issueTypeList.length; i++) {
      if (Number(id) === Number(remoteSearch.issueTypeList[i].id)) {
        return remoteSearch.issueTypeList[i];
      }
    }
    return {};
  };

  return (
    <NoFooterModal
      header
      heading="Apply filters"
      handleClose={handleModalClose}
      id="filtersModalSubIssueTypes"
      modalButtons={
        <BottomSectionModal className="flex item-center justify-between">
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
            appearance="outline"
          >
            Clear
          </Button>
          <Button
            data-testid="launchAppReleaseBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <InfiniteScrollDropdown
        id="issueTypeInfiniteDropDown"
        setPriorityFlag={setPriorityFlag}
        priorityFlag={priorityFlag}
        getActiveList={getIssueTypeRemoteSearch}
        nextPage={remoteSearch.nextPage}
        resKey="data" // key to get the list
        keyName="issueType"
        modalState={"Edit"}
        labelKey="issue" // key for label
        // getDataLabelKey="issueType"
        keyTypeToSet="id" // key to return the data of
        label="Issue Type"
        handleChange={handleChange}
        activeElement={filterFieldState}
        getActiveItemById={getActiveItemById}
        appliedFilters={{}}
        width="50%"
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
      />
      <Input
        id="sushi-input"
        value={filterFieldState.issueTypeId}
        fullWidth={true}
        label="Issue Type Id"
        type="number"
        onChange={(val) => handleChange("issueTypeId", val)}
      />
      <Input
        id="sushi-input"
        value={filterFieldState.name}
        fullWidth={true}
        label="Sub Issue Name"
        onChange={(val) => handleChange("name", val)}
      />
      <Input
        id="sushi-input"
        value={filterFieldState.externalMappingName}
        fullWidth={true}
        label="External Mapping Name"
        type="text"
        onChange={(val) => handleChange("externalMappingName", val)}
      />
      <PaginatedReactDropdown
        options={enabledType}
        handleChange={handleChange}
        keyToChange="enabled"
        placeholder="Enabled"
        showCross={true}
        id="issueTypeField"
        fullWidth={true}
        labelWidth="auto"
        value={filterFieldState.enabled}
      />
      <PaginatedReactDropdown
        options={issueArea}
        handleChange={handleChange}
        keyToChange="issueArea"
        placeholder="Issue Area"
        labelKey="name"
        valueKey="name"
        showCross={true}
        id="issueTypeField"
        fullWidth={true}
        labelWidth="auto"
        value={filterFieldState.issueArea}
      />
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { IssueTypes, SubIssueTypes } = state;
  return {
    issueArea: IssueTypes.issueArea,
    activeFilters: SubIssueTypes.activeFilters,
    currentPage: SubIssueTypes.currentPage,
    remoteSearch: IssueTypes.remoteSearch,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getIssueArea: bindActionCreators(IssueTypesActions.getIssueArea, dispatch),
    getIssueTypeList: bindActionCreators(
      IssueTypesActions.getIssueTypeList,
      dispatch
    ),
    setSubIssueTypeActiveFilters: bindActionCreators(
      SubIssueTypeActions.setSubIssueTypeActiveFilters,
      dispatch
    ),
    getSubIssueTypeList: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypesList,
      dispatch
    ),
    getIssueTypeRemoteSearch: bindActionCreators(
      SubIssueTypeActions.getIssueTypeRemoteSearch,
      dispatch
    ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubIssueTypeFilterModal);
